module.exports = __webpack_public_path__ + "static/media/model3.16bbf2f9.jpg";